import React from "react";
import { Helmet } from "react-helmet-async";
import useFullUrl from "web/core/shop/useFullUrl";

const ProductSeo = (props) => {
  const fullProductUrl = useFullUrl(props.product.path);
  const ogImage = useFullUrl(props.product.imageUrl);

  return (
    <Helmet encodeSpecialCharacters={false}>
      <title>{props.product.meta_title}</title>
      <meta name="description" content={props.product.meta_description} />

      {/* Open Graph tags */}
      <meta property="og:type" content="product" />
      <meta property="og:title" content={props.product.meta_title} />
      <meta
        property="og:description"
        content={props.product.meta_description}
      />
      <meta
        property="product:price:amount"
        content={props.product.prices.finalPrice.priceInclTax.value.amount}
      />
      <meta
        property="product:price:currency"
        content={props.product.prices.finalPrice.priceInclTax.value.currency}
      />
      <meta property="og:url" content={fullProductUrl} />
      <meta property="og:image" content={ogImage} />

      {/* Twitter card */}
      <meta name="twitter:card" content="summary" />

      <link rel="canonical" href={fullProductUrl} />
    </Helmet>
  );
};

export default ProductSeo;
